import { ISimpleBonusAction, SimpleSlotGameState } from "../api";
import { ScreenProtocolMessage } from "../ScreenProtocol";
import { SlotSpinResult, IRunResult } from "./SlotGame";
import { GetStateNameCallback } from "./StateMachine";
	
	/**************************************************************************
		Slot game screen protocol sync messages
	**************************************************************************/
export namespace SlotGameMessages {

	// export class DenomChange extends ScreenProtocolMessage
	// {
	// 	public static readonly msgname = "denomchange";
	// 	public denom: number;
	// 	public locality: string;

	// 	public constructor(denom: number, locality: string) {
	// 		super(DenomChange.msgname);

	// 		this.denom = denom;
	// 		this.locality = locality;
	// 	}
	// }

	export class BetChange extends ScreenProtocolMessage
	{
		public static readonly msgname = "betChange";
		public bet: number;
		public betTotalCredit: number;

		public constructor(betTotalCredit: number) {
			super(BetChange.msgname);
			this.betTotalCredit = betTotalCredit;
		}
	}

	export class StateChange<T> extends ScreenProtocolMessage
	{
		public static readonly msgname = "statechange";
		public oldState: T;
		public newState: T;

		public oldStateName: string;
		public newStateName: string;

		public constructor(oldState: T, newState: T, stateNameCallback: GetStateNameCallback<T>) {
			super(StateChange.msgname);

			this.oldState = oldState;
			this.newState = newState;

			this.oldStateName = stateNameCallback(oldState);
			this.newStateName = stateNameCallback(newState);
		}
	}

	export class SpinResult extends ScreenProtocolMessage
	{
		public static readonly msgname = "spinresult";
		public spin: SimpleSlotGameState;

		public constructor(spin: SimpleSlotGameState) {
			super(SpinResult.msgname);
			this.spin = spin;
		}
	}

	export class BonusStart extends ScreenProtocolMessage
	{
		public static readonly msgname = "bonusstart";
		public bonus: string;

		public constructor(bonus: string) {
			super(BonusStart.msgname);
			this.bonus = bonus;
		}
	}

	export class WiningSymbol extends ScreenProtocolMessage
	{
		public static readonly msgname = "winingSymbols";
		public symbol: number;

		public constructor(symbol: number) {
			super(WiningSymbol.msgname);
			this.symbol = symbol;
		}
	}

	export class BonusRunResult extends ScreenProtocolMessage
	{
		public static readonly msgname = "BonusRunResult";
		public run: ISimpleBonusAction[];

		public constructor(run: ISimpleBonusAction[]) {
			super(BonusRunResult.msgname);
			this.run = run;
		}
	}

	export class BonusFinished extends ScreenProtocolMessage
	{
		public static readonly msgname = "BonusFinished";
		public bonus: string;
		public constructor(bonus?: string) {
			super(BonusFinished.msgname);
			this.bonus = bonus
		}
	}

	
	
}